import { title } from "process";
import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  title: { value: "", matchMode: "contains" },
  description: { value: "", matchMode: "contains" },
  category: { value: "", matchMode: "equals" },
  isPrivate: { value: "", matchMode: "equals" },
  order: { value: "", matchMode: "equals" },
  allowedRoles: { value: "", matchMode: "contains" },

};

export const useFilterDocumentFilesStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));